import { GetUserInfoApi } from "@/request/api"
export default {
    namespaced: true,
    state: {
        userInfo: JSON.parse(localStorage.getItem("xbd-userInfo")) || {
            user: null,
            term: null,
        }
    },
    mutations: {
        changeUserInfo(state, payload) {
            state.userInfo = payload;
            localStorage.setItem("xbd-userInfo", JSON.stringify(state.userInfo));
        }
    },
    // 发请求
    actions: {
        async asyncChangeUserInfo({ commit }, payload) {
            let GetUserInfoApiRes = await GetUserInfoApi();
            console.log(GetUserInfoApiRes);
            if (!GetUserInfoApiRes) return;
            commit("changeUserInfo", {
                user: GetUserInfoApiRes.name,
                term: GetUserInfoApiRes.term,
            })
        }
    }

}